/**
 * 50 most used currencies - shared with React Native app
 */

export interface CurrencyOption {
  code: string;
  symbol: string;
  label: string;
}

export const CURRENCIES: CurrencyOption[] = [
  { code: "USD", symbol: "$", label: "US Dollar ($)" },
  { code: "EUR", symbol: "€", label: "Euro (€)" },
  { code: "GBP", symbol: "£", label: "British Pound (£)" },
  { code: "JPY", symbol: "¥", label: "Japanese Yen (¥)" },
  { code: "CNY", symbol: "¥", label: "Chinese Yuan (¥)" },
  { code: "CHF", symbol: "Fr", label: "Swiss Franc (Fr)" },
  { code: "CAD", symbol: "C$", label: "Canadian Dollar (C$)" },
  { code: "AUD", symbol: "A$", label: "Australian Dollar (A$)" },
  { code: "NZD", symbol: "NZ$", label: "New Zealand Dollar (NZ$)" },
  { code: "NIS", symbol: "₪", label: "Israeli Shekel (₪)" },
  { code: "INR", symbol: "₹", label: "Indian Rupee (₹)" },
  { code: "BRL", symbol: "R$", label: "Brazilian Real (R$)" },
  { code: "KRW", symbol: "₩", label: "South Korean Won (₩)" },
  { code: "MXN", symbol: "MX$", label: "Mexican Peso (MX$)" },
  { code: "SGD", symbol: "S$", label: "Singapore Dollar (S$)" },
  { code: "HKD", symbol: "HK$", label: "Hong Kong Dollar (HK$)" },
  { code: "NOK", symbol: "kr", label: "Norwegian Krone (kr)" },
  { code: "SEK", symbol: "kr", label: "Swedish Krona (kr)" },
  { code: "DKK", symbol: "kr", label: "Danish Krone (kr)" },
  { code: "ZAR", symbol: "R", label: "South African Rand (R)" },
  { code: "RUB", symbol: "₽", label: "Russian Ruble (₽)" },
  { code: "TRY", symbol: "₺", label: "Turkish Lira (₺)" },
  { code: "PLN", symbol: "zł", label: "Polish Zloty (zł)" },
  { code: "THB", symbol: "฿", label: "Thai Baht (฿)" },
  { code: "IDR", symbol: "Rp", label: "Indonesian Rupiah (Rp)" },
  { code: "MYR", symbol: "RM", label: "Malaysian Ringgit (RM)" },
  { code: "PHP", symbol: "₱", label: "Philippine Peso (₱)" },
  { code: "CZK", symbol: "Kč", label: "Czech Koruna (Kč)" },
  { code: "HUF", symbol: "Ft", label: "Hungarian Forint (Ft)" },
  { code: "CLP", symbol: "CL$", label: "Chilean Peso (CL$)" },
  { code: "COP", symbol: "CO$", label: "Colombian Peso (CO$)" },
  { code: "ARS", symbol: "AR$", label: "Argentine Peso (AR$)" },
  { code: "PEN", symbol: "S/", label: "Peruvian Sol (S/)" },
  { code: "EGP", symbol: "E£", label: "Egyptian Pound (E£)" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham (د.إ)" },
  { code: "SAR", symbol: "﷼", label: "Saudi Riyal (﷼)" },
  { code: "QAR", symbol: "QR", label: "Qatari Riyal (QR)" },
  { code: "KWD", symbol: "د.ك", label: "Kuwaiti Dinar (د.ك)" },
  { code: "BHD", symbol: "BD", label: "Bahraini Dinar (BD)" },
  { code: "OMR", symbol: "OMR", label: "Omani Rial (OMR)" },
  { code: "JOD", symbol: "JD", label: "Jordanian Dinar (JD)" },
  { code: "TWD", symbol: "NT$", label: "Taiwan Dollar (NT$)" },
  { code: "VND", symbol: "₫", label: "Vietnamese Dong (₫)" },
  { code: "NGN", symbol: "₦", label: "Nigerian Naira (₦)" },
  { code: "KES", symbol: "KSh", label: "Kenyan Shilling (KSh)" },
  { code: "PKR", symbol: "₨", label: "Pakistani Rupee (₨)" },
  { code: "BDT", symbol: "৳", label: "Bangladeshi Taka (৳)" },
  { code: "UAH", symbol: "₴", label: "Ukrainian Hryvnia (₴)" },
  { code: "RON", symbol: "lei", label: "Romanian Leu (lei)" },
  { code: "BGN", symbol: "лв", label: "Bulgarian Lev (лв)" },
];

export function getCurrencySymbol(code: string): string {
  return CURRENCIES.find((c) => c.code === code)?.symbol ?? code;
}
